(() => {
  const meaningful = node => node.nodeType === Node.ELEMENT_NODE || (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0);
  const compact = root => {
    if (root.dataset.roCondensed === 'true') return;
    root.dataset.roCondensed = 'true';
    root.querySelectorAll('[style]').forEach(element => ['font-family','font-size','font-style','line-height','letter-spacing','color','background-color','text-transform'].forEach(property => element.style.removeProperty(property)));
    root.querySelectorAll('font').forEach(element => ['face','size','color'].forEach(attribute => element.removeAttribute(attribute)));
    let content = root;
    while (content.children.length === 1 && content.firstElementChild.tagName === 'DIV' && !content.firstElementChild.classList.contains('ro-description-panel')) content = content.firstElementChild;
    const nodes = Array.from(content.childNodes);
    if (content.textContent.trim().length < 450 && nodes.filter(meaningful).length < 5 && root.dataset.roCollapseAll !== 'true') return;
    const output = document.createDocumentFragment();
    const introLimit = root.dataset.roCollapseAll === 'true' ? 0 : 2;
    let introCount = 0;
    let buffer = [];
    let heading = null;
    const flush = () => {
      const hasBody = buffer.some(meaningful);
      if (!hasBody && !heading) { buffer.forEach(node => output.append(node)); buffer = []; return; }
      const details = document.createElement('details');
      details.className = 'ro-description-section';
      const summary = document.createElement('summary');
      if (heading) summary.append(heading);
      else {
        summary.textContent = root.dataset.roDetailsLabel || 'Product details';
        summary.dataset.roGenerated = 'true';
      }
      const panel = document.createElement('div');
      panel.className = 'ro-description-panel';
      buffer.forEach(node => panel.append(node));
      details.append(summary, panel);
      output.append(details);
      buffer = [];
      heading = null;
    };
    nodes.forEach(node => {
      const tag = node.nodeType === Node.ELEMENT_NODE ? node.tagName : '';
      if (tag === 'DETAILS') { flush(); output.append(node); return; }
      if (tag === 'H2' || tag === 'H3' || tag === 'H4') { flush(); heading = node; introCount = introLimit; return; }
      if (introCount < introLimit && !heading) {
        output.append(node);
        if (meaningful(node)) introCount += 1;
      } else buffer.push(node);
    });
    flush();
    content.replaceChildren(output);
  };
  const scan = () => document.querySelectorAll('.product__description, .ro-compact-copy').forEach(compact);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  const target = document.getElementById('MainContent');
  if (target) new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length > 0)) scan();
  }).observe(target, { childList: true, subtree: true });
})();